const open = (options) => {
	const {
		target,
		callback
	} = options;
	
	const windowProxy = window.open("about:blank", target, "menubar=no,location=no,resizable=no,scrollbars=yes,status=yes");
	
	const handler = (event) => {
		const data = event.data;
		
		if( data === true ) {
			windowProxy.close();
			window.removeEventListener('message', handler);
			callback();
		} else {
			//console.log("Invalid message: ", data, event);
        }
	}	
	
	const checkWindowClosed = () => {
		if( windowProxy.closed ) {
			window.removeEventListener('message', handler);
			console.log("window is closed, remove handler");
			clearTimeout(timeout);
		}
	};
	
	const timeout = setInterval(checkWindowClosed, 250);	
	window.addEventListener('message', handler);
	
	return (redirectedUri) => {
		windowProxy.location.replace(redirectedUri);
	}
}  

export {
	open
};